// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1_tr6","cls2":"ImpactHubModal-cls2_dj6 ImpactHubModal-cls1_tr6"};